
  import {init as runtimeInit, loadRemote} from "@module-federation/runtime";
  
  import exposesMap from "virtual:mf-exposes:host__remoteEntry-_hash_"
  import {usedShared, usedRemotes} from "/home/runner/work/entity-console/entity-console/applications/admin/.__mf__temp/host/localSharedImportMap"
  import {
    initResolve
  } from "__mf__virtual/host__mf_v__runtimeInit__mf_v__.js"
  const initTokens = {}
  const shareScopeName = "default"
  const mfName = "host"
  async function init(shared = {}, initScope = []) {
    const initRes = runtimeInit({
      name: mfName,
      remotes: usedRemotes,
      shared: usedShared,
      plugins: [],
      shareStrategy: 'version-first'
    });
    // handling circular init calls
    var initToken = initTokens[shareScopeName];
    if (!initToken)
      initToken = initTokens[shareScopeName] = { from: mfName };
    if (initScope.indexOf(initToken) >= 0) return;
    initScope.push(initToken);
    initRes.initShareScopeMap('default', shared);
    initResolve(initRes)
    try {
      await Promise.all(await initRes.initializeSharing('default', {
        strategy: 'version-first',
        from: "build",
        initScope
      }));
    } catch (e) {
      console.error(e)
    }
    return initRes
  }

  function getExposes(moduleName) {
    if (!(moduleName in exposesMap)) throw new Error(`Module ${moduleName} does not exist in container.`)
    return (exposesMap[moduleName])().then(res => () => res)
  }
  export {
      init,
      getExposes as get
  }
  